import { NotificationApi } from "@/services/api/Notification.service";
import store from "@/store";
import { provideApolloClient, useSubscription } from "@vue/apollo-composable";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import {
  NOTIFICATION_STORE,
  FETCH_NOTIFICATION,
  FETCH_EMAIL_NOTIFICATION,
  FETCH_SMS_NOTIFICATION,
  SET_EMAIL_NOTIFICATION,
  SET_SMS_NOTIFICATION,
  GET_EMAIL_NOTIFICATION,
  GET_SMS_NOTIFICATION,
  SET_NOTIFICATION_SUBSCRIPTION,
  MUTATION_NOTIFICATION_SUBSCRIPTION,
  GET_NOTIFICATION__SUBSCRIPTION,
  FETCH_UNREAD_CONVERSATION,
  MUTATION_UNREAD_CONVERSATION,
  UNREAD_CONVERSATION,
  GET_UNREAD_CONVERSATION,
  FETCH_GRAPHQL_DATA,
  GET_GRAPHQL_DATA,
  SET_GRAPHQL_DATA,
  SET_APOLLO_CLIENT,
} from "./types";
import NOTIFICATION_SUBSCRIPTION from "@/graphql/notificationSubscription.graphql";
import { apolloClient } from "@/config/apolloClient";
import { INotificationData } from "@/interfaces/iNotification";
import { IConversationUnreadCount, IGraphQlData } from "@/interfaces/iMessage";
@Module({
  name: NOTIFICATION_STORE,
  namespaced: true,
  dynamic: true,
  store,
})
export default class NotificationStore extends VuexModule {
  EMAIL_NOTIFICATION = 0;
  SMS_NOTIFICATION = 0;
  NOTIFICATION_DATA = {} as INotificationData;
  UNREAD_CONVERSATION: IConversationUnreadCount[] = [];
  GRAPHQL_DATA = {} as IGraphQlData;

  get [GET_SMS_NOTIFICATION](): number {
    return this.SMS_NOTIFICATION;
  }
  get [GET_EMAIL_NOTIFICATION](): number {
    return this.EMAIL_NOTIFICATION;
  }
  get [GET_NOTIFICATION__SUBSCRIPTION](): INotificationData {
    return this.NOTIFICATION_DATA;
  }
  get [GET_UNREAD_CONVERSATION](): IConversationUnreadCount[] {
    return this.UNREAD_CONVERSATION;
  }
  get [GET_GRAPHQL_DATA](): IGraphQlData {
    return this.GRAPHQL_DATA;
  }

  @Mutation
  [SET_EMAIL_NOTIFICATION](count: number) {
    this.EMAIL_NOTIFICATION = count;
  }
  @Mutation
  [SET_SMS_NOTIFICATION](count: number) {
    this.SMS_NOTIFICATION = count;
  }
  @Mutation
  [MUTATION_NOTIFICATION_SUBSCRIPTION](data: INotificationData) {
    this.NOTIFICATION_DATA = data;
  }
  @Mutation
  [MUTATION_UNREAD_CONVERSATION](data: IConversationUnreadCount[]) {
    this.UNREAD_CONVERSATION = data;
  }
  @Mutation
  [SET_GRAPHQL_DATA](data: IGraphQlData) {
    this.GRAPHQL_DATA = data;
  }

  @Action
  async [FETCH_NOTIFICATION]() {
    this.context.dispatch(FETCH_EMAIL_NOTIFICATION);
    this.context.dispatch(FETCH_SMS_NOTIFICATION);
  }
  @Action
  async [FETCH_EMAIL_NOTIFICATION]() {
    const data = await NotificationApi.getInstance().unReadEmailCount();
    this.context.commit(SET_EMAIL_NOTIFICATION, data);
  }
  @Action
  async [FETCH_SMS_NOTIFICATION]() {
    const data = await NotificationApi.getInstance().unReadSmsCount();
    this.context.commit(SET_SMS_NOTIFICATION, data);
    await this.context.dispatch(FETCH_UNREAD_CONVERSATION);
  }
  @Action({ rawError: true })
  async [SET_NOTIFICATION_SUBSCRIPTION]() {
    const userId = await this.context.rootGetters["currentUser"].webId;
    provideApolloClient(apolloClient);
    const { result } = useSubscription<INotificationData>(
      NOTIFICATION_SUBSCRIPTION,
      {
        userId,
      }
    );
    this.context.commit(MUTATION_NOTIFICATION_SUBSCRIPTION, result);
  }
  @Action
  async [FETCH_UNREAD_CONVERSATION]() {
    const data = await NotificationApi.getInstance().conversationUnreadCount();
    this.context.commit(MUTATION_UNREAD_CONVERSATION, data);
  }
  @Action({ rawError: true })
  async [FETCH_GRAPHQL_DATA]() {
    return new Promise((resolve, reject) => {
      NotificationApi.getInstance()
        .getGraphQlInfo()
        .then((data) => {
          this.context.commit(SET_GRAPHQL_DATA, data);
          resolve(data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
  // Set Apollo Client
  @Action({ rawError: true })
  async [SET_APOLLO_CLIENT]() {
    if (!this.context.getters[GET_GRAPHQL_DATA].url) {
      await this.context.dispatch(FETCH_GRAPHQL_DATA);
    }
    // const apolloClientData = apolloClient(
    //   this.context.getters[GET_GRAPHQL_DATA]
    // );
    // provideApolloClient(apolloClientData)(() => {
    //   const { onResult: onCurrentuserResult } =
    //     useCurrentUserUpdatedSubscription(() => ({
    //       enabled: this.$state.loggedIn,
    //       clientId: "myCustomClientId",
    //     }));
    // });
  }
}
